/**
 * An item picker shows a variant by its code, the way the team says it: "G · 1L", "HG · 500ml" (the owner, 2026-10-24).
 * Milk comes first (G, G+, G++, then the halves, then the rest), ghee and butter after it.
 */
export interface VariantRow { id: string; code: string; size_class: string | null }

const MILK_ORDER = ['G', 'G+', 'G++', 'HG', 'HG+', 'HG++'];

function rank(code: string): number {
  const i = MILK_ORDER.indexOf(code);
  if (i >= 0) return i;
  return /^(GHEE|BUTTER)/.test(code) ? 200 : 100;
}

export function variantOptions(rows: VariantRow[]): { value: string; label: string }[] {
  return [...rows]
    .sort((a, b) => rank(a.code) - rank(b.code) || a.code.localeCompare(b.code))
    .map((v) => ({ value: v.id, label: `${v.code}${v.size_class ? ` · ${v.size_class}` : ''}` }));
}
